import { Button } from '@jouzen/ecom-components/v3/Button';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

export interface TestimonialCardFooterProps {
  readonly nameMsgKey: MessageKey | undefined;
  readonly name: string | undefined;
  readonly company: string | undefined;
  readonly action:
    | {
        link: string;
        messageKey: MessageKey;
      }
    | undefined;
}

const TestimonialCardFooter = ({
  nameMsgKey,
  name,
  company,
  action,
}: TestimonialCardFooterProps) => {
  const t = useTranslations();
  return (
    <>
      {(nameMsgKey ?? name) && (
        <Typography
          className="text-base font-normal xxl:text-heading-xs"
          color="inherit"
          data-cy={`testimonial-card-footer-name-${nameMsgKey ?? name}`}
          Element="div"
        >
          {nameMsgKey ? t(nameMsgKey) : name}
        </Typography>
      )}
      {company && (
        <Typography
          data-cy={`testimonial-card-footer-company-${company}`}
          className="text-sm"
        >
          {company}
        </Typography>
      )}
      {action && (
        <Button
          className="text-inherit sm:mt-1 md:mt-6"
          data-cy={`testimonial-card-footer-action-link-${action.messageKey}`}
          href={action.link}
          size="none"
          target="_blank"
          variant="primary-text-link"
        >
          {t(action.messageKey)}
        </Button>
      )}
    </>
  );
};
export default TestimonialCardFooter;
